import http from 'hub-http/clients/apiClient';
const API_BASE = 'app-users/v1/users';
export default class AppUsersApi {
  static getUser({
    userId
  }) {
    return http.get(`${API_BASE}/${userId}`);
  }
}